import { clsx } from "clsx"

type LabelProps = {
  readonly className?: string
  readonly children: React.ReactNode
  readonly type?: "default" | "primary" | "inverse" | "white"
  readonly size?: "xs" | "sm"
  readonly tag?: "span" | "h2"
}

export function Label({
  className,
  children,
  type = "default",
  size = "sm",
  tag = "span",
}: LabelProps) {
  const Tag = tag

  return (
    <Tag
      className={clsx(
        className,
        "label inline-block w-fit select-none whitespace-nowrap uppercase leading-none tracking-label",
        "[.label+&]:border-nobel [.label+&]:border-l",
        type === "default" && "text-dim",
        type === "white" && "text-white",
        type === "primary" && "font-theme-bold text-primary",
        type === "inverse" &&
          "bg-primary px-1 py-0.5 font-theme-bold text-white tracking-wider",
        size === "xs" &&
          "text-2xs [&:not(:last-child)]:mr-[0.5ch] [.label+&]:pl-[0.5ch]",
        size === "sm" &&
          "text-xs [&:not(:last-child)]:mr-[0.75ch] [.label+&]:pl-[0.75ch]",
      )}
    >
      {children}
    </Tag>
  )
}
